import React from 'react'

export type ScoreProps = {
    score: number
    maxScore: number
    color?: boolean
    className?: string
} & Omit<React.HTMLAttributes<HTMLSpanElement>, 'className' | 'color'>

export const Score = ({ score, maxScore, color, className, ...params }: ScoreProps) => {
    const getColorClass = () => {
        if (!color) return ''
        const threshold = maxScore * 0.6
        return score <= threshold ? 'text-[#FF484B]' : 'text-[#08AC81]'
    }

    const baseClass = color ? getColorClass() : 'text-[#08AC81]'
    const combinedClassName = `${baseClass} ${className || ''}`.trim()

    return <span className={combinedClassName} {...params}>{`${score}/${maxScore}`}</span>
}
